import { Typography, Box, Icon } from '@mui/material';
import { useTheme } from '@mui/material';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { formatDateToJalali, numberToTomans } from '../../utils/helpers';
import Badge from '../base/BaseBadge/BaseBadge';
import CountdownTimer from '../base/CountdownTimer/CountdownTimer';
const OrderItem = ({ item, onChange }) => {
    const theme= useTheme();
    
    const getBadgeProps = (status) => {
        switch (status) {
            case 0:
                return { type: "warning", text: "در انتظار" };
            case 1:
                return { type: "success", text: "تایید شده" };
            case 2:
                return { type: "error", text: "رد شده" };
            default:
                return { type: "error", text: "" };
        }
    };

    const badgeProps = getBadgeProps(item.status);
    const getRemainingTime = () => Math.round(((new Date(item.createdAt).getTime() + 60000) - new Date().getTime()) / 1000)

    return (
        <Box
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{ 
                width: "100%",
                margin: "5px 0",
                padding: "10px",
                borderRadius: "10px",
                border: "1px solid"
            }}
        >
            <Box
                display="flex"
                flexDirection="column"
                justifyContent="flex-start"
                alignItems="center"
                gap={2}
                sx={{ width: "10%", flexGrow: 1 }}
            >
                <Icon
                    sx={{
                        display: 'flex',
                        fontSize: 24,
                        color: item.orderType === 'buy' ? theme.palette.success.main : theme.palette.error.main,
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                >
                    {item.orderType === 'buy' ? <ArrowUpwardIcon/> : <ArrowDownwardIcon/>}
                </Icon>
            </Box>
            <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="flex-start"
                gap={2}
                sx={{ width: "60%", flexGrow: 1 }}
            >
                <Box
                    display="flex"
                    flexDirection="row"
                    justifyContent="center"
                    alignItems="center"
                >
                    <Typography
                        variant='caption2'
                    >
                        {item.orderType === 'buy' ? "خرید " : "فروش "}
                        {item.productName}
                    </Typography>
                    <Typography
                        variant='subtitle2'
                        sx={{
                            color: theme.palette.text.gray
                        }}
                    >
                        {` (${item.amount} ${item.productId === 1 || item.productId === 2 || item.productId === 25 ? "گرم" : "عدد" })`}
                    </Typography>
                </Box>
                <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    gap={2}
                >
                    <Typography
                        variant='caption2'
                        sx={{
                            color: theme.palette.text.gray
                        }}
                    >
                        {formatDateToJalali(item.createdAt)}
                    </Typography>
                </Box>
            </Box>
            <Box
                display="flex"
                flexDirection="column"
                justifyContent="flex-start"
                alignItems="center"
                gap={1}
                sx={{ width: "30%", flexGrow: 1 }}
            >
                <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    gap={2}
                >
                    <Typography
                        variant='subtitle2'
                        sx={{
                            color: theme.palette.text.gray
                        }}
                    >
                        {numberToTomans(item.price.totalPrice)}{" تومان"}
                    </Typography>
                </Box>
                <Box
                    display="flex"
                    flexDirection="row"
                    justifyContent="center"
                    alignItems="center"
                    gap={2}
                >
                    <Badge {...badgeProps} />
                    { (item.status === 0) && <CountdownTimer time={60} left={getRemainingTime()} onComplete={onChange} /> }
                </Box>
            </Box>
            <Box
                display="flex"
                flexDirection="column"
                justifyContent="flex-start"
                alignItems="center"
                gap={2}
                sx={{ width: "5%", flexGrow: 1 }}
            >
                <Icon
                    sx={{
                        display: 'flex',
                        fontSize: 24,
                        color: theme.palette.background.gray,
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                >
                    <ChevronLeftIcon/>
                </Icon>
            </Box>
        </Box>
    );
};

export default OrderItem;
